export default __webpack_public_path__ + "static/default-image-5e51324f804a0ff42d9366eb78793d52.jpg";